import Dictionary from "./Dictionary";
import logo from "./logo.png";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary />
        </main>
        <footer className="App-footer">
          <small>
            Coded by{" "}
            <a
              href="https://github.com/kateacraig"
              target="_blank"
              rel="noreferrer"
            >
              Kate Craig
            </a>
            , open sourced on{" "}
            <a
              href="https://github.com/kateacraig/dictionary-project"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            , and hosted by{" "}
            <a
              href="https://dictionary-project-kc.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              Netlify
            </a>
            .
          </small>
        </footer>
      </div>
    </div>
  );
}
